<app-maintenance-window />
<div [attr.data-theme]="theme()" class="size-full page">
  <router-outlet></router-outlet>
</div>
